import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Şifrenizi Mi Unuttunuz ?"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, "Telefon Numaranızı Giriniz.")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Telefon", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Telefonunuza gelen şifre", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("İptal")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
        disabled: _ctx.hide,
        class: "form-control form-control-solid",
        type: "text",
        placeholder: "",
        name: "phone",
        autocomplete: "off"
      }, null, 8, _hoisted_5), [
        [_vModelText, _ctx.phone]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ErrorMessage, { name: "email" })
        ])
      ])
    ]),
    _hoisted_8,
    (_ctx.hide)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            class: "form-control form-control-solid",
            type: "text",
            placeholder: "",
            name: "password",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      (!_ctx.hide)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "submit",
            class: "btn btn-lg btn-primary fw-bolder me-4",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.okeybutton && _ctx.okeybutton(...args)))
          }, " Tamamla "))
        : _createCommentVNode("", true),
      (_ctx.hide)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "submit",
            class: "btn btn-lg btn-primary fw-bolder me-4",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitForgotPassword && _ctx.onSubmitForgotPassword(...args)))
          }, " Gönder "))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/sign-in",
        class: "btn btn-lg btn-light-primary fw-bolder"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ])
  ]))
}